// extracted by mini-css-extract-plugin
module.exports = {"footer":"TypeFormFooter-module__footer___3IbtO","unlockDuration":"TypeFormFooter-module__unlockDuration___3tB4B"};